import React, { useEffect, useRef } from 'react';
import styled from 'styled-components/macro';
import { connect } from 'react-redux';
import {
  switchLanguage,
  fetchCategories,
  fetchTechMessage,
  updateSearchKeyword,
  channelsFetchData,
  fetchProfiles,
  setProfile,
  signOutUser,
  searchResultsRequest,
} from '../actions';
import translate from './TranslateHOC';
import { setTheme, getTheme, usePrevious } from '../helpers';
import * as c from '../constants';
import { default as HeaderV2 } from '../v2/components/header/Header';
import IsLoadingAnim from './alerts/IsLoadingAnim';
import { bindActionCreators } from 'redux';
import { show } from 'redux-modal';
import LoadingError from '../components/alerts/LoadingError';
import TechnicalError from '../components/alerts/TechnicalError';

function Header({
  strings,
  auth,
  channels,
  channelsIsLoading,
  channelsHasErrored,
  techMessage,
  techMessageError,
  profileId,
  location,
  history,
  updateSearchKeyword,
  categories,
  setProfile,
  searchKeyword,
  profilesData,
  fetchCats,
  fetchTechMessage,
  curLang,
  fetchChannels,
  switchLang,
  getSearchResults,
  fetchProfiles,
  signOutUser,
  show,
}) {
  let currentProfileImg;
  const genres = categories?.categories;
  const profileData = profilesData?.profiles;
  const iOS = document.body.classList.contains('ios-faux-fullscreen');

  const handleOpen = (name) => () => {
    const trans = strings;
    show(c.CONFIRM_DIALOG, {
      message: trans.confirmSignOut,
      confirmLbl: trans.signOut,
      cancelLbl: trans.cancel,
      handleSubmit: signOut,
    });
  };

  const submitSearchRequest = (_searchKeyword) => {
    getSearchResults(_searchKeyword.trim());
  };

  const signOut = () => {
    signOutUser();
  };

  const prevCurLang = usePrevious(curLang);

  useEffect(() => {
    fetchCats();
    fetchChannels();
    fetchProfiles();
    setTheme(getTheme());
    fetchTechMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (typeof prevCurLang !== 'undefined' && prevCurLang !== curLang) {
      fetchCats();
      fetchChannels();
      fetchTechMessage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [curLang]);

  if (profileData) {
    currentProfileImg = profileData?.find(
      (obj) => parseInt(obj.id, 10) === parseInt(profileId, 10)
    )?.avatar_filename
      ? window.AVATAR_IMG_PATH +
        profileData.find(
          (obj) => parseInt(obj.id, 10) === parseInt(profileId, 10)
        ).avatar_filename
      : window.AVATAR_IMG_PATH + c.DEFAULT_PROFILE_IMG;
  }

  if (channelsIsLoading) {
    return <IsLoadingAnim />;
  }

  if (channelsHasErrored) {
    return (
      <HeaderContainer iOS={iOS}>
        <LoadingError errorMessage={strings.sorryLoading} />
      </HeaderContainer>
    );
  }

  return (
    <HeaderContainer iOS={iOS}>
      {techMessage && !techMessageError && techMessage.error && (
        <TechnicalError errorMessage={techMessage} />
      )}
      <HeaderV2
        className="header"
        strings={strings}
        location={location}
        history={history}
        updateSearchKeyword={updateSearchKeyword}
        changeLang={() => switchLang(curLang)}
        channels={channels}
        categories={categories}
        genres={genres}
        auth={auth}
        currentProfileImg={currentProfileImg}
        profileId={profileId}
        profileData={profileData}
        currentPath={location.pathname}
        setProfile={setProfile}
        signOutUser={handleOpen(c.CONFIRM_SIGN_OUT_DIALOG)}
        searchKeyword={searchKeyword}
        submitSearchRequest={submitSearchRequest}
      />
    </HeaderContainer>
  );
}

const HeaderContainer = styled.div`
  ${(props) =>
    props.iOS &&
    `
      display: none;
  `};
`;

function mapStateToProps(state) {
  return {
    curLang: state.curLang,
    categories: state.categories.success,
    auth: state.auth.authenticated,
    techMessage: state.techMessage.success,
    techMessageError: state.techMessage.error,
    channels: state.channels.success,
    channelsIsLoading: state.channels.loading,
    channelsHasErrored: state.channels.error,
    profilesData: state.profilesData.success,
    profileName: state.profileName,
    profileId: state.profileId,
    searchKeyword: state.searchKeyword.success,
    searchResults: state.searchResults.success,
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    switchLang: (lang) => dispatch(switchLanguage(lang)),
    fetchCats: (lang) => dispatch(fetchCategories(lang)),
    fetchCats: (lang) => dispatch(fetchCategories(lang)),
    getSearchResults: (keywords) => dispatch(searchResultsRequest(keywords)),
    updateSearchKeyword: (lang) => dispatch(updateSearchKeyword(lang)),
    fetchChannels: () => dispatch(channelsFetchData()),
    fetchProfiles: (lang) => dispatch(fetchProfiles(lang)),
    fetchTechMessage: (lang) => dispatch(fetchTechMessage(lang)),
    setProfile: (lang, id) => dispatch(setProfile(lang, id)),
    signOutUser: () => dispatch(signOutUser()),
    show: bindActionCreators(show, dispatch),
  };
};

export default translate(connect(mapStateToProps, mapDispatchToProps)(Header));
